import { render, staticRenderFns } from "./newSlideshow.vue?vue&type=template&id=a5da8e2c&scoped=true&"
import script from "./newSlideshow.vue?vue&type=script&lang=js&"
export * from "./newSlideshow.vue?vue&type=script&lang=js&"
import style0 from "./newSlideshow.vue?vue&type=style&index=0&id=a5da8e2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5da8e2c",
  null
  
)

export default component.exports